<template>
  <v-card class="component-container card-add-collaborator">
    <v-form
      v-model="isFormValid"
      class="h-100 d-flex flex-column"
      @submit.prevent="addCollaborator"
    >
      <v-btn
        variant="plain"
        class="return-btn"
        size="small"
        prepend-icon="mdi-chevron-left"
        @click="$emit('clicked')"
        :ripple="false"
      >
        {{ $t('COMMON.BUTTON.BACK') }}
      </v-btn>

      <v-container class="logo-container">
        <img alt="logo Boomerang" class="logo" src="@/assets/images/boomerang_black_logo.png" />
      </v-container>

      <v-spacer />

      <v-container>
        <p class="subtitle">{{ $t('LOGIN_PAGE.TITLE.FIRSTNAME') }}</p>
        <v-text-field v-model="collaborator.firstname" :rules="requiredRules" />

        <p class="subtitle">{{ $t('LOGIN_PAGE.TITLE.LASTNAME') }}</p>
        <v-text-field v-model="collaborator.lastname" :rules="requiredRules" />
      </v-container>

      <v-spacer />

      <v-container>
        <v-btn
          class="boom-button"
          variant="outlined"
          @click="addCollaborator"
          :disabled="loading || !isFormValid"
          :loading="loading"
        >
          {{ $t('LOGIN_PAGE.BUTTON.ADD_COLLABORATOR') }}
          <v-icon icon="mdi-arrow-right" />
        </v-btn>
      </v-container>
    </v-form>
  </v-card>
</template>

<script>
import router from '@/router'
import Validator from '@/components/utils/validator'
import CollaboratorService from '@/services/CollaboratorService'
import { displayToast } from '@/components/utils/globalFunction'

export default {
  name: 'addCollaboratorPage',

  data() {
    return {
      loading: false,
      isFormValid: false,
      collaborator: {
        firstname: '',
        lastname: ''
      },
      parent: 'loginPage',
      requiredRules: Validator.requiredRules
    }
  },
  methods: {
    async addCollaborator() {
      this.loading = true
      try {
        const response = await CollaboratorService.createCollaborator(this.collaborator)
        // Find the Collaborator added to get ID for localStorage
        const newCollaborator = this.getNewCollaboratorId(
          this.$store.state.auth.userDetail.collaboratorList,
          response.item_list
        )
        this.$store.commit('auth/updateCollaboratorsList', response.item_list)
        this.$store.commit('auth/selectedCollaborator', newCollaborator[0].technical_id)
        displayToast(this.$t('LOGIN_ADD_COLLABORATOR.MESSAGE.SUCCESS'), 'success')
        await router.push({ path: '/dashboard' })
      } catch (error) {
        displayToast(this.$t('LOGIN_ADD_COLLABORATOR.MESSAGE.ERROR'), 'error')
      } finally {
        this.loading = false
      }
    },
    getNewCollaboratorId(list_store, list_response) {
      let diff = []

      list_store.forEach((item1) => {
        if (!list_response.some((item2) => item2.technical_id === item1.technical_id)) {
          diff.push(item1)
        }
      })

      list_response.forEach((item2) => {
        if (!list_store.some((item1) => item1.technical_id === item2.technical_id)) {
          diff.push(item2)
        }
      })

      return diff
    }
  }
}
</script>

<style scoped>
.link:hover {
  color: #559a1b;
}

.subtitle {
  font-size: 100%;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  margin-bottom: 2%;
}

:deep(.v-field) {
  overflow: hidden;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

:deep(.v-text-field .v-input__details) {
  padding-inline-start: unset;
  padding-inline-end: unset;
}

:deep(.v-field__input) {
  background: none;
  height: 20% !important;
}

.card-add-collaborator {
  z-index: 2;
  position: absolute;
}

.subtitle {
  line-height: 20px;
  text-align: left;
  margin-bottom: 2%;
}

.boom-button {
  width: 100%;
}

.component-container {
  overflow-y: auto;
  border-radius: 20px;
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: auto 5%;
  padding: 0 7%;
}

@media (max-width: 499px) {
  .component-container {
    width: 90vw;
    height: calc(100vh - 5%);
  }
}

@media (min-width: 500px) and (max-width: 767px) {
  .component-container {
    width: 70vw;
    height: calc(100vh - 5%);
  }
}

@media (min-width: 768px) and (max-width: 1099px) {
  .component-container {
    width: 40vw;
    height: 80vh;
  }
}

@media (min-width: 1100px) and (max-width: 1599px) {
  .component-container {
    width: 30vw;
    height: 80vh;
  }
}

@media (min-width: 1600px) {
  .component-container {
    width: 20vw;
    height: 80vh;
  }
}

:deep(.v-text-field .v-input__details) {
  padding-inline-start: unset;
  padding-inline-end: unset;
}

.logo-container {
  margin-right: auto;
  margin-left: auto;
  margin-top: 50px;
  padding: unset;
}

.logo {
  display: flex;
  flex-direction: column;
  margin: auto;
  align-items: center;
  justify-content: center;
  width: 90%;
}

.return-btn {
  display: flex;
  justify-content: start;
  position: absolute;
  top: 25px;
  left: 25px;
  color: black;
}

.return-btn:hover {
  color: #559a1b;
}
</style>
